import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = ({ language }) => {
  const content = {
    sq: {
      title: 'Politika e Privatësisë',
      lastUpdated: 'Përditësuar më: 24 Shkurt 2026',
      sections: [
        {
          title: '1. Informacion i Përgjithshëm',
          content: 'Gjenerali SHPK respekton privatësinë tuaj dhe është e angazhuar për të mbrojtur të dhënat tuaja personale. Kjo politikë e privatësisë shpjegon se si ne mbledhim, përdorim dhe mbrojmë informacionin tuaj.'
        },
        {
          title: '2. Të Dhënat që Mbledhim',
          content: `Ne mbledhim llojet e mëposhtme të të dhënave:

• Analitikë Faqeje: Adresa IP (anonimizuar), vendi/qyteti, faqet e vizituara, lloji i shfletuesit, koha e vizitës
• Formulari i Kontaktit: Emri, email, telefoni, mesazhi
• Cookies: Vetëm për funksionalitet bazik dhe analitikë (me pëlqimin tuaj)

Të gjitha të dhënat ruhen në mënyrë të sigurt dhe nuk ndahen me palë të treta.`
        },
        {
          title: '3. Si i Përdorim të Dhënat',
          content: `Ne përdorim të dhënat tuaja për:

• Të përmirësuar përvojën tuaj në faqe
• Të analizuar trafikun e faqes
• Të përgjigjemi në pyetjet tuaja
• Të ofrojmë shërbime më të mira

Ne NUKE i shesim ose ndajmë të dhënat tuaja me palë të treta.`
        },
        {
          title: '4. Cookies',
          content: `Ne përdorim cookies për:

• Funksionalitet bazik të faqes
• Analitikë (vetëm me pëlqimin tuaj)
• Sesioni i administratorit (httpOnly, i sigurt)

Ju mund të refuzoni cookies jo-esenciale në çdo kohë.`
        },
        {
          title: '5. Ruajtja e të Dhënave',
          content: `• Analitikë: Fshihen automatikisht pas 90 ditësh
• Mesazhet e Kontaktit: Ruhen derisa të fshihen nga administratori
• Audit Logs: Fshihen automatikisht pas 1 viti

Të dhënat e vjetra fshihen automatikisht për të minimizuar ruajtjen.`
        },
        {
          title: '6. Të Drejtat Tuaja (GDPR)',
          content: `Sipas GDPR, ju keni të drejtën:

• Të aksesoni të dhënat tuaja
• Të kërkoni fshirjen e të dhënave
• Të eksportoni të dhënat tuaja
• Të tërhiqni pëlqimin për cookies
• Të korrigjoni informacionin e pasaktë

Për të ushtruar këto të drejta, na kontaktoni në: altion.basha@gjenerali.al`
        },
        {
          title: '7. Siguria',
          content: `Ne marrim masa të forta sigurie:

• Enkriptim SSL/HTTPS
• Fjalëkalime të hash-uara
• Mbrojtje nga sulmet (rate limiting, XSS, CSRF)
• Akses i kufizuar në të dhëna
• Backup të rregullta

Të dhënat tuaja janë të sigurta me ne.`
        },
        {
          title: '8. Kontakti',
          content: `Për çdo pyetje rreth privatësisë:

Email: altion.basha@gjenerali.al
Telefon: +355 68 209 1156
Adresa: Manëz, Shqipëri
Website: https://gjenerali.al`
        }
      ]
    },
    en: {
      title: 'Privacy Policy',
      lastUpdated: 'Last Updated: February 24, 2026',
      sections: [
        {
          title: '1. General Information',
          content: 'Gjenerali SHPK respects your privacy and is committed to protecting your personal data. This privacy policy explains how we collect, use, and protect your information.'
        },
        {
          title: '2. Data We Collect',
          content: `We collect the following types of data:

• Website Analytics: IP address (anonymized), country/city, pages visited, browser type, visit time
• Contact Forms: Name, email, phone, message
• Cookies: Only for basic functionality and analytics (with your consent)

All data is stored securely and not shared with third parties.`
        },
        {
          title: '3. How We Use Data',
          content: `We use your data to:

• Improve your website experience
• Analyze website traffic
• Respond to your inquiries
• Provide better services

We DO NOT sell or share your data with third parties.`
        },
        {
          title: '4. Cookies',
          content: `We use cookies for:

• Basic website functionality
• Analytics (only with your consent)
• Admin session (httpOnly, secure)

You can reject non-essential cookies at any time.`
        },
        {
          title: '5. Data Retention',
          content: `• Analytics: Automatically deleted after 90 days
• Contact Messages: Stored until deleted by admin
• Audit Logs: Automatically deleted after 1 year

Old data is automatically deleted to minimize storage.`
        },
        {
          title: '6. Your Rights (GDPR)',
          content: `Under GDPR, you have the right to:

• Access your data
• Request data deletion
• Export your data
• Withdraw cookie consent
• Correct inaccurate information

To exercise these rights, contact us at: altion.basha@gjenerali.al`
        },
        {
          title: '7. Security',
          content: `We take strong security measures:

• SSL/HTTPS encryption
• Hashed passwords
• Protection against attacks (rate limiting, XSS, CSRF)
• Limited data access
• Regular backups

Your data is safe with us.`
        },
        {
          title: '8. Contact',
          content: `For any privacy questions:

Email: altion.basha@gjenerali.al
Phone: +355 68 209 1156
Address: Manëz, Albania
Website: https://gjenerali.al`
        }
      ]
    }
  };

  const text = content[language] || content.sq;

  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <h1>{text.title}</h1>
        <p className="last-updated">{text.lastUpdated}</p>
        
        {text.sections.map((section, index) => (
          <div key={index} className="privacy-section">
            <h2>{section.title}</h2>
            <p style={{ whiteSpace: 'pre-line' }}>{section.content}</p>
          </div>
        ))}

        <div className="privacy-footer">
          <p>© 2026 Gjenerali SHPK. Të gjitha të drejtat e rezervuara.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
